// extracted by mini-css-extract-plugin
export default {"buttonWrapper":"roles_actions-module___buttonWrapper___d969ded4"};